import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]
  static values = { speed: { type: Number, default: 0.4 } }

  connect() {
    this.onScroll = () => this.update()
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  update() {
    const rect = this.element.getBoundingClientRect()
    const windowH = window.innerHeight
    const sectionH = this.element.offsetHeight
    const imageH = this.imageTarget.naturalHeight
      ? (this.imageTarget.offsetHeight)
      : this.imageTarget.offsetHeight

    // Only apply if image is taller than section
    const overflow = imageH - sectionH
    if (overflow <= 0) return

    // Progress: 0 when section enters bottom, 1 when it leaves top
    const progress = 1 - (rect.bottom / (windowH + sectionH))
    const clamped = Math.max(0, Math.min(1, progress))

    // Move image up by overflow amount as user scrolls
    const translateY = -(clamped * overflow)
    this.imageTarget.style.transform = `translateY(${translateY}px)`
  }
}
